import { Permission, Role } from 'appwrite'

// Droits par défaut d'un créateur AW, posés explicitement pour l'user de la session effective
// (en impersonation : la cible). undefined → AW applique ses permissions par défaut.
export const userOwnPermissions = (userId?: string) => userId
   ? [Permission.read(Role.user(userId)), Permission.update(Role.user(userId)), Permission.delete(Role.user(userId))]
   : undefined
